const REACH_TYPE = 'reach'
const SPEND_TYPE = 'spend'
const IMPRESSIONS_TYPE = 'impressions'
const CLICKS_TYPE = 'clicks'
const CPM_TYPE = 'cpm'
const CTR_TYPE = 'ctr'
const IMPRESSION_SPEND_TYPE = 'impressionSpend'
const RATES_TYPE = 'rates'
const CREATIVE_CLICKS_TYPE = 'creativeClicks'
const CITY_TYPE = 'city'
const DEVICE_TYPE = 'device'
const CAMPAIGNS_TYPE = 'campaigns'
const PLACEMENTS_TYPE = 'placements'
const CITY_PLACEMENTS_TYPE = 'city-impressions'
const DEVICE_PLACEMENTS_TYPE = 'device-impressions'
const CHART_ERROR = 'Ошибка при загрузке данных типа'

const COLORS = {
  orange: '#ffa000',
  red: '#ee1d52',
  blue: '#0028ff',
  green: '#284912',
  violet: '#861be4',
  greenLight: '#42cf7b',
  black: '#000018',
  olive: '#67AAAF',
  // rates: '#000000',
  // creativeClicks: '#ff00ff',
}

const SUMMARY_COLORS = {
  blue: '#0029ff',
  purple: '#a97dbe',
  sageBlue: '#67aaaf',
  lilac: '#cc7dff',
  periwinkle: '#677ddf',
  violet: '#861be4',
}

const DEVICES_COLORS = {
  'Mobile/Tablet': '#a1b0ff',
  Tablet: '#8c9eff',
  Phone: '#4f6aff',
  'Personal Computer': '#001fc5',
}

const TYPE_CHARTS = {
  SPEND: SPEND_TYPE,
  IMPRESSIONS: IMPRESSIONS_TYPE,
  CLICKS: CLICKS_TYPE,
  CPM: CPM_TYPE,
  CTR: CTR_TYPE,
  REACH: REACH_TYPE,
  GEO: 'geo',
  DEVICES: 'devices',
  RATE: RATES_TYPE,
  CREATIVE: 'creative',
  IMPRESSION_SPEND: IMPRESSION_SPEND_TYPE,
}

const ALL_CHART_ITEMS = [
  {text: 'chartItems.spend', value: TYPE_CHARTS.SPEND},
  {text: 'chartItems.impression', value: TYPE_CHARTS.IMPRESSIONS},
  {text: 'chartItems.click', value: TYPE_CHARTS.CLICKS},
  {text: 'chartItems.cpm', value: TYPE_CHARTS.CPM},
  {text: 'chartItems.ctr', value: TYPE_CHARTS.CTR},
  {text: 'chartItems.reach', value: TYPE_CHARTS.REACH},
  {text: 'chartItems.geo', value: TYPE_CHARTS.GEO},
  {text: 'chartItems.devices', value: TYPE_CHARTS.DEVICES},
  {text: 'chartItems.impressionSpend', value: TYPE_CHARTS.IMPRESSION_SPEND},
  {text: 'chartItems.rate', value: TYPE_CHARTS.RATE},
  {text: 'chartItems.creative', value: TYPE_CHARTS.CREATIVE},
]

const CHART_ITEMS = [
  {text: 'label.statSpend', value: SPEND_TYPE, color: SUMMARY_COLORS.blue},
  {text: 'label.statImpressions', value: IMPRESSIONS_TYPE, color: SUMMARY_COLORS.purple},
  {text: 'label.statClicks', value: CLICKS_TYPE, color: SUMMARY_COLORS.sageBlue},
  {text: 'label.statCpm', value: CPM_TYPE, color: SUMMARY_COLORS.lilac},
  {text: 'label.statCtr', value: CTR_TYPE, color: SUMMARY_COLORS.periwinkle},
  {text: 'label.reach', value: REACH_TYPE, color: SUMMARY_COLORS.violet},
]

const SUMMARY_CHARTS = [
  {
    key: SPEND_TYPE,
    series: [],
    info: {
      text: '',
      subtitle: '',
      color: SUMMARY_COLORS.blue,
    },
    label: 'label.statSpend',
    name: 'Spend',
    data: [],
    currency: undefined,
    isCurrency: true,
  },
  {
    key: IMPRESSIONS_TYPE,
    series: [],
    info: {
      text: '',
      subtitle: '',
      color: SUMMARY_COLORS.purple,
    },
    label: 'label.statImpressions',
    name: 'Impression',
    data: [],
    currency: undefined,
  },
  {
    key: CLICKS_TYPE,
    series: [],
    info: {
      text: '',
      subtitle: '',
      color: SUMMARY_COLORS.sageBlue,
    },
    label: 'label.statClicks',
    name: 'Click',
    data: [],
    currency: undefined,
  },
  {
    key: CPM_TYPE,
    series: [],
    info: {
      text: '',
      subtitle: '',
      color: SUMMARY_COLORS.lilac,
    },
    label: 'label.statCpm',
    name: 'Cpm',
    data: [],
    currency: undefined,
    isCurrency: true,
  },
  {
    key: CTR_TYPE,
    series: [],
    info: {
      text: '',
      subtitle: '',
      color: SUMMARY_COLORS.periwinkle,
    },
    label: 'label.statCtr',
    name: 'Ctr',
    data: [],
    currency: undefined,
  },
  {
    key: REACH_TYPE,
    series: [],
    info: {
      text: '',
      subtitle: '',
      color: SUMMARY_COLORS.violet,
    },
    label: 'label.reach',
    name: 'Reach',
    data: [],
    currency: undefined,
  },
]

export {
  REACH_TYPE,
  SPEND_TYPE,
  IMPRESSIONS_TYPE,
  CLICKS_TYPE,
  CPM_TYPE,
  CTR_TYPE,
  IMPRESSION_SPEND_TYPE,
  RATES_TYPE,
  CREATIVE_CLICKS_TYPE,
  CITY_TYPE,
  DEVICE_TYPE,
  CAMPAIGNS_TYPE,
  PLACEMENTS_TYPE,
  CITY_PLACEMENTS_TYPE,
  DEVICE_PLACEMENTS_TYPE,
  CHART_ITEMS,
  SUMMARY_CHARTS,
  CHART_ERROR,
  ALL_CHART_ITEMS,
  TYPE_CHARTS,
  COLORS,
  SUMMARY_COLORS,
  DEVICES_COLORS,
}
